<template>
  <div>
    <div id="t_map" ref="mapRef" v-bind="$attrs" class="w-full h-full"></div>
    <slot v-if="loaded" />
  </div>
</template>

<script>
import { Scene } from "@antv/l7";
import {
  BaiduMap,
  TMap,
} from "@antv/l7-maps";
import {
  defineComponent,
  onMounted,
  provide,
  ref,
  shallowRef,
} from "@nuxtjs/composition-api";

import { load } from "./map-loader";

const NAME = "l7-map";

export default defineComponent({
  name: NAME,
  props: {
    center: {
      type: [Array, Object],
    },
  },
  setup(props, { emit }) {
    const scene = shallowRef(null);
    const mapRef = ref(null);
    const map = shallowRef(null);
    const loaded = ref(false);
    onMounted(async () => {
      // @ts-ignore
      if (!window.T) {
        await load({ tk: "f934ec15ff894ad6b3588ae7552fc786" });
      }

      const mapInstance = new window.T.Map(mapRef.value, {
        // @ts-ignore
        center: window.T.LngLat(121.30654632240122, 31.25744185633306),
        minZoom: 5,
        maxZoom: 15,
        projection: "EPSG:900913",
      });
      // const _map = new BaiduMap({
      //   center: [107.054293, 35.246265],
      //   zoom: 4.056,
      //   token: "eq9qyXSMGH99WEQxxE8MzSF7IpmE7mcP",
      //   // 百度地图的logo是否可见，默认true
      //   logoVisible: false,
      // });
      scene.value = new Scene({
        id: "t_map",
        map: new TMap({
          mapInstance,
        }),
        loginVisible: false,
        preserveDrawingBuffer: true,
      });

      map.value = mapInstance;

      scene.value.on("loaded", () => {
        loaded.value = true;

        mapInstance.enableContinuousZoom(true);
        mapInstance.setMinZoom(5);
        mapInstance.setMaxZoom(15);
        emit("loaded", scene.value);
      });
    });

    provide(NAME, {
      scene,
      map,
    });

    return {
      scene,
      map,
      mapRef,
      loaded,
    };
  },
  methods: {
    getZoom() {
      return this.scene.getZoom();
    },
    setZoom(zoom) {
      this.scene.setZoom(zoom);
    },
    panTo(lnglat) {
      this.map.panTo(new window.T.LngLat(lnglat[0], lnglat[1]));
    },
    setCenter(lnglat) {
      this.scene.setCenter(lnglat);
    },
  },
});
</script>

<style lang="scss" scoped>

</style>
